import { fromFetch } from 'rxjs/fetch';
import { switchMap, of, catchError } from 'rxjs';
import { getMetroSpecificArticles } from 'constants/routes'

/**
 * getMetroSpecifics: observable to fetch the metro specific article section
 * response.text() to map the partial result
 */
 const getMetroSpecifics$ = (metroAreaSectionCommand) => {
  const requestObject = {
    method: 'POST',
    body: JSON.stringify({
      buildMetroAreaSectionCommand: {
        ...metroAreaSectionCommand,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  };

  return fromFetch(getMetroSpecificArticles, requestObject).pipe(
    switchMap((response) => response.text()),
    catchError(() => of(''))
  );
}

export default getMetroSpecifics$;